import React from "react";

const DoYouActuallyNeedBoth = ({ data }) => {
    if (!data) return null;

    return (
        <div className="keyDifference">
            <h4 className="title">{data?.title}</h4>
            {data?.paragraph?.map((para, paraIndex) => {
                return (
                    <div key={paraIndex}>
                        <p className="paragraph">{para?.para}<b>{para?.paraBold}</b>{para?.para1}</p>
                    </div>
                )
            })}
        </div>
    );
};

export default DoYouActuallyNeedBoth;